import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { MessageCircle, ArrowRight } from 'lucide-react';

const CTASection = () => {
  const { language, t } = useLanguage();

  return (
    <section className="py-24 bg-teal-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t.cta.title}
        </h2>
        <p className="text-teal-100 text-lg mb-8 max-w-2xl mx-auto">
          {t.cta.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-white text-teal-700 hover:bg-stone-100 px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all">
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </Button>
          </a>
          <a href={`mailto:${siteInfo.email}`}>
            <Button
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-700 px-8 py-6 text-lg transition-all"
            >
              {t.contact.email}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;